import { authService } from '@/modules/auth/services/authService';

const BASE_URL = window.pov_config.VUE_APP_API_URL_GATEWAY;
const STREAM_ROUTE = '/v3/ai/aiagents/chat/message/stream';

const getAuthHeaders = async (forceRefresh = false) => {
  const tokenResult = await authService.getToken(forceRefresh);
  if (!tokenResult?.success || !tokenResult?.jwt) {
    throw new Error('AUTH_FAILED');
  }
  return {
    'Content-Type': 'application/json',
    'x-app-name': 'Frontage-pov',
    Authorization: `Bearer ${tokenResult.jwt}`,
  };
};

const parseSseBlock = (block) => {
  let eventType = null;
  const dataLines = [];

  block.split('\n').forEach((line) => {
    if (line.startsWith('event: ')) {
      eventType = line.slice(7).trim();
    } else if (line.startsWith('data: ')) {
      dataLines.push(line.slice(6));
    } else if (line === 'data:') {
      dataLines.push('');
    }
  });

  if (!eventType || dataLines.length === 0) return null;
  return { type: eventType, text: dataLines.join('\n') };
};

const doStreamRequest = async (headers, payload) => {
  const response = await fetch(`${BASE_URL}${STREAM_ROUTE}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  return response;
};

/**
 * POST /chat/message/stream — same for a new user message or for HITL (omit `message`, pass `confirmed`).
 */
const streamMessage = async (payload, onEvent) => {
  let headers = await getAuthHeaders();
  let response = await doStreamRequest(headers, payload);

  if (response.status === 401) {
    headers = await getAuthHeaders(true);
    response = await doStreamRequest(headers, payload);
  }

  if (!response.ok) {
    throw new Error(`Stream request failed: ${response.status}`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();

  const processChunk = (buffer) => reader.read().then(({ done, value }) => {
    if (done) return Promise.resolve();
    const newBuffer = buffer + decoder.decode(value, { stream: true });
    const blocks = newBuffer.split('\n\n');
    const remaining = blocks.pop();
    blocks
      .filter((block) => !block.startsWith(':'))
      .forEach((block) => {
        const event = parseSseBlock(block);
        if (event) onEvent(event);
      });
    return processChunk(remaining);
  });

  await processChunk('');
};

export default {
  streamMessage,
};
